import { render, staticRenderFns } from "./bulma_pagination.vue?vue&type=template&id=3d7e238c&scoped=true&lang=html"
import script from "./bulma_pagination.vue?vue&type=script&lang=js"
export * from "./bulma_pagination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d7e238c",
  null
  
)

export default component.exports